<template>
	<component :is="componentName" />
</template>

<script>
import { VUE_APP_VERSION } from '@/helpers/environment'
import { mapGetters } from 'vuex'

import { os, version, browserEngine, browserName, browserVersion } from '@/helpers/device'

export default {
	name: 'LandingSwap',
	components: {
		Landing: () => import('@/views/Landing.vue'),
		LandingTT: () => import('@/views/LandingTT.vue'),
		LandingDEShort: () => import('@/views/LandingDEShort.vue'),
		LandingYT: () => import(/* webpackChunkName: "landing-yt" */ '@/views/LandingYT.vue'),
		LandingFemaleQuiz: () => import('@/views/LandingFemaleQuiz.vue')
	},
	computed: {
		...mapGetters({
			language: 'i18n/getLanguage',
			domain: 'location/domain',
			hostname: 'location/hostname',
			getQueryParam: 'location/getQueryParam',
			onetrustActiveGroups: 'onetrust/getActiveGroups'
		}),
		componentName() {
			if (this.component) {
				return this.component
			} else if (this.domain.SIMPLEAPP) {
				return this.IS_FEMALE_FUNNEL || this.IS_MALE_FUNNEL ? 'Landing' : 'LandingTT'
			} else if (this.language === 'de' && !this.IS_MALE_FUNNEL && !this.IS_FEMALE_FUNNEL) {
				return 'LandingDEShort'
			} else if (this.domain.YOUTUBE) {
				return 'LandingYT'
			} else if (this.IS_FEMALE_FUNNEL_HW_EXP) {
				return 'LandingFemaleQuiz'
			} else {
				return 'Landing'
			}
		}
	},

	created() {
		this.$analytic
			.setUserProperties({
				Device: { os, version },
				browserEngine,
				browserName,
				browserVersion,
				SurveyVersion: VUE_APP_VERSION,
				locale: this.$i18n.locale,
				CookieConsentActiveGroups: this.onetrustActiveGroups,
				hostname: this.hostname,
				from: this.getQueryParam('from'),
				AdgroupId: this.getQueryParam('adgroup_id'),
				AdId: this.getQueryParam('ad_id'),
				CampaignId: this.getQueryParam('campaign_id'),
				UtmCampaign: this.getQueryParam('utm_campaign'),
				UtmContent: this.getQueryParam('utm_content'),
				UtmGender: this.getQueryParam('utm_gender'),
				UtmMedium: this.getQueryParam('utm_medium'),
				UtmPartnerId: this.getQueryParam('utm_partner_id'),
				UtmSource: this.getQueryParam('utm_source'),
				UtmTerm: this.getQueryParam('utm_term')
			})
			.then(() => {
				this.$analytic.logEvent('ScreenView', { title: 'OnboardingWelcomeScreen' })
				this.$analytic.logEvent('OnboardingStart', { from: this.getQueryParam('from') })
			})
	},

	beforeRouteEnter(to, from, next) {
		if (to.name === 'landing' && from.path === '/') {
			window.ot.startSpan?.('vue-landing-mounted', 'app-start', {
				startTime: window.ot.startTime,
				attributes: {
					'span.type': 'vue-landing-mounted'
				}
			})
		}
		next()
	}
}
</script>
